import { CorvalBusinessFunction, CorvalQueryBusinessFunctionsArgs } from '@src/types';
import { queriesLoading }                                           from '@src/store/_apolloUtil';
import { QueryTuple, useLazyQuery, useQuery }                       from '@apollo/react-hooks';
import { DecisionEngineQueries }                                    from '@src/queries';
import { OperationVariables }                                       from '@apollo/react-common';


type UseSystemDataHookMethod = () => UseSystemDataHook;

export type UseSystemDataHook = {
    dataLoading: boolean,
    businessFunctionsQuery: QueryTuple<{ businessFunctions: CorvalBusinessFunction[] }, CorvalQueryBusinessFunctionsArgs>
    businessFunctions: CorvalBusinessFunction[],
};

const businessFunctionQueryFragment = DecisionEngineQueries.queries.GET_BUSINESS_FUNCTIONS();
const businessFunctionQueryOptions: OperationVariables = {
    variables:   { order: { name: 'ASC' } },
    fetchPolicy: 'cache-and-network'
};

export const useSystemData: UseSystemDataHookMethod = () => {

    const businessFunctionsReq = useQuery<{ businessFunctions: CorvalBusinessFunction[] }>( businessFunctionQueryFragment, businessFunctionQueryOptions ),
          getBusinessFunctions = useLazyQuery( businessFunctionQueryFragment, businessFunctionQueryOptions );

    const isLoading = queriesLoading( [
        businessFunctionsReq
    ] );

    return {
        dataLoading:            isLoading,
        businessFunctions:      businessFunctionsReq.data?.businessFunctions ?? [],
        businessFunctionsQuery: getBusinessFunctions
    };
};
